import { BeDataTable, BeStack, BeText } from "@beos-css/react/index.ts";

/** The R5 system fonts, from app_server's `system_default_fonts[]` (Notes/40). */
const FACES = [
	{ face: "control", r5: "be_plain_font 10", use: "buttons, labels, body" },
	{ face: "menu", r5: "plain 12", use: "menus and menubars" },
	{ face: "tab", r5: "be_bold_font 12", use: "window-tab titles" },
	{ face: "mini", r5: "plain 9", use: "Tracker column headers" },
] as const;

export function TextFaceDemo() {
	return (
		<section id="demo-text-face">
			<h2>Text faces (BeText face=)</h2>
			<p>
				Three text roles and one sub-control size — R5 had no h1..h6. Family and size are ONE decision: each coverage face is native at
				exactly one ppem, so a size without its family resamples. Omit <code>face</code> inside a control, which already sets both.
			</p>
			<BeStack pad="item" className="be-panel">
				<BeDataTable tags>
					<thead>
						<tr>
							<th>face</th>
							<th>R5 font</th>
							<th>where</th>
							<th>sample</th>
						</tr>
					</thead>
					<tbody>
						{FACES.map((f) => (
							<tr key={f.face}>
								<td>{f.face}</td>
								<td>{f.r5}</td>
								<td>{f.use}</td>
								<td className="be-data-table__fill">
									<BeText face={f.face}>Hamburgefonstiv 0123</BeText>
								</td>
							</tr>
						))}
					</tbody>
				</BeDataTable>
			</BeStack>
		</section>
	);
}
